module.exports = __webpack_public_path__ + "static/media/303RowLabel--G.63006ef0.svg";